import { render, staticRenderFns } from "./AttributesForTaxiCell.vue?vue&type=template&id=433329c6&scoped=true&"
import script from "./AttributesForTaxiCell.vue?vue&type=script&lang=js&"
export * from "./AttributesForTaxiCell.vue?vue&type=script&lang=js&"
import style0 from "./AttributesForTaxiCell.vue?vue&type=style&index=0&id=433329c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433329c6",
  null
  
)

export default component.exports